export default __webpack_public_path__ + "static/media/Care09.f8e8a35b.png";